import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileComponent } from './pages/profile/profile.component';
import { ChangePasswordComponent } from './pages/profile/pages/change-password/change-password.component';
import { PinComponent } from './pages/pin/pin.component';
import { RekeningComponent } from './pages/rekening/rekening.component';
import { DocumentComponent } from './pages/document/document.component';
import { SlaDataInputComponent } from './pages/document/pages/sla-data-input/sla-data-input.component';
import { SlaSubmissionComponent } from './pages/document/pages/sla-submission/sla-submission.component';
import { CaDataInputComponent } from './pages/document/pages/ca-data-input/ca-data-input.component';
import { CaSubmissionComponent } from './pages/document/pages/ca-submission/ca-submission.component';
import { UatInputComponent } from './pages/document/pages/uat-input/uat-input.component';
import { TeamsComponent } from './pages/teams/teams.component';
import { AddTeamComponent } from './pages/teams/pages/add-team/add-team.component';
import { ExpeditionComponent } from './pages/expedition/expedition.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { SlaDataInputQrislyComponent } from './pages/document/pages/sla-data-input-qrisly/sla-data-input-qrisly.component';
import { SlaSubmissionQrislyComponent } from './pages/document/pages/sla-submission-qrisly/sla-submission-qrisly.component';
import { UatInputPaymentComponent } from './pages/document/pages/uat-input-payment/uat-input-payment.component';
import { VerificationTeamComponent } from './pages/teams/pages/verification-team/verification-team.component';
import { VerificationSuccessComponent } from './pages/teams/pages/verification-success/verification-success.component';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { MenuAccessGuard } from 'src/app/guards/menu-access.guard';
import { RoleRedirectGuard } from 'src/app/guards/role.guard';

const routes: Routes = [
  // When loaded via 'account' or 'profile'
  { path: 'profile', component: ProfileComponent },
  { path: 'profile/change-password', component: ChangePasswordComponent },
  { path: 'pin', component: PinComponent, canActivate: [MenuAccessGuard] },
  { path: 'bank-account', component: RekeningComponent, canActivate: [MenuAccessGuard] },
  {
    path: 'teams',
    canActivate: [RoleRedirectGuard, MenuAccessGuard],
    children: [
      { path: '', component: TeamsComponent },
      { path: 'add-team', component: AddTeamComponent, canActivate: [AuthGuard] },
      { path: 'edit-team/:id', component: AddTeamComponent, canActivate: [AuthGuard] },
    ],
  },
  {
    path: 'document',
    canActivate: [MenuAccessGuard],
    children: [
      { path: '', component: DocumentComponent },
      { path: 'sla-data-input', component: SlaDataInputComponent },
      { path: 'sla-data-input-qrisly', component: SlaDataInputQrislyComponent },
      { path: 'submission-sla', component: SlaSubmissionComponent },
      { path: 'submission-sla-qrisly', component: SlaSubmissionQrislyComponent },
      { path: 'ca-data-input', component: CaDataInputComponent },
      { path: 'submission-ca', component: CaSubmissionComponent },
      { path: 'uat-data-input', component: UatInputComponent },
      { path: 'uat-data-input-payment', component: UatInputPaymentComponent },
    ],
  },
  { path: 'expedition', component: ExpeditionComponent, canActivate: [RoleRedirectGuard] },
  { path: 'payment', component: PaymentComponent },

  // Default redirect
  { path: '', redirectTo: 'profile', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PengaturanRoutingModule {}
